import { KeyLabel } from './KeyLabel';
export const KeyLabelNeo2: KeyLabel[] = [
  {
    code: 0,
    label: '(layer 4)',
  },
  {
    code: 4,
    label: 'U',
  },
  {
    code: 5,
    label: 'Z',
  },
  {
    code: 6,
    label: 'Ä',
  },
  {
    code: 7,
    label: 'A',
  },
  {
    code: 8,
    label: 'L',
  },
  {
    code: 9,
    label: 'E',
  },
  {
    code: 10,
    label: 'O',
  },
  {
    code: 11,
    label: 'S',
  },
  {
    code: 12,
    label: 'G',
  },
  {
    code: 13,
    label: 'N',
  },
  {
    code: 14,
    label: 'R',
  },
  {
    code: 15,
    label: 'T',
  },
  {
    code: 16,
    label: 'M',
  },
  {
    code: 17,
    label: 'B',
  },
  {
    code: 18,
    label: 'F',
  },
  {
    code: 19,
    label: 'Q',
  },
  {
    code: 20,
    label: 'X',
  },
  {
    code: 21,
    label: 'C',
  },
  {
    code: 22,
    label: 'I',
  },
  {
    code: 23,
    label: 'W',
  },
  {
    code: 24,
    label: 'H',
  },
  {
    code: 25,
    label: 'P',
  },
  {
    code: 26,
    label: 'V',
  },
  {
    code: 27,
    label: 'Ö',
  },
  {
    code: 28,
    label: 'K',
  },
  {
    code: 29,
    label: 'Ü',
  },
  {
    code: 30,
    label: '1',
  },
  {
    code: 31,
    label: '2',
  },
  {
    code: 32,
    label: '3',
  },
  {
    code: 33,
    label: '4',
  },
  {
    code: 34,
    label: '5',
  },
  {
    code: 35,
    label: '6',
  },
  {
    code: 36,
    label: '7',
  },
  {
    code: 37,
    label: '8',
  },
  {
    code: 38,
    label: '9',
  },
  {
    code: 39,
    label: '0',
  },
  {
    code: 45,
    label: '-',
  },
  {
    code: 46,
    label: '` (dead)',
  },
  {
    code: 47,
    label: 'ß',
  },
  {
    code: 48,
    label: '´ (dead)',
  },
  {
    code: 50,
    label: '(layer 3)',
  },
  {
    code: 51,
    label: 'D',
  },
  {
    code: 52,
    label: 'Y',
  },
  {
    code: 53,
    label: '^ (dead)',
  },
  {
    code: 54,
    label: ',',
  },
  {
    code: 55,
    label: '.',
  },
  {
    code: 56,
    label: 'J',
  },
  {
    code: 57,
    label: '(layer 3)',
  },
  {
    code: 100,
    label: '(layer 4)',
  },
];
